import AnnualSummaryError from './AnnualSummaryError';
class AnnualSummaryInvalidFiscalRegime extends AnnualSummaryError {
    fiscalRegime;
    constructor(fiscalRegime, options) {
        super('Fiscal regime code is not valid', options);
        this.fiscalRegime = fiscalRegime;
    }
}
export default AnnualSummaryInvalidFiscalRegime;
